export const environment = {
	production: true,
	development: false,
	HTTP: { api_url: 'http://Mobilityonchangesserver-env.eba-qyxv3pby.us-east-2.elasticbeanstalk.com' },
	HTTPS: { api_url: 'https://webclient.mobilityltd.net:3000' },
};
